import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import VideoBox from "../../casinoComponents/videoBox";
import CasinoHeading from "../../casinoComponents/casinoHeading";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import MyBet from "../../casinoComponents/myBet";
import RefCardsOverlay from "../../casinoComponents/videoBox/overlays/RefCardsOverlay";
import ViewMoreModal from "../../../components/ViewMoreModal";
import LottRefResults from "./LottRefResults";
import { getCasinoGameDetails, getCasinoOpenBets } from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";
import "../../../styles/games/lottcard.css";
import { formatLottcardNation } from "../../../utils/casinoMyBets";

/**
 * Lottery (API type lottcard) — reference admin page casino/lottery:
 *   .casino-table.lottery > .game-header ("Lottery") + .casino-video (3-card overlay)
 *   + .casino-remark.mt-1 (when the feed has a remark) + .mb-3 > .casino-video-last-results.
 * The reference admin shows no bet table for this game (and no "Last Result" title).
 */
export default function LottCard() {
  const [gameData, setGameData] = useState(null);
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);

  const { pathname } = useLocation();
  const gameName = extractCasinoGame(pathname) || "lottcard";

  useEffect(() => {
    const name = extractCasinoGame(pathname) || "lottcard";
    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
      } catch (err) {
        console.error("Error fetching Lottery game data: ", err);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, [pathname]);

  // My Bets: GET /lords/bet-list/casino/open-downline?gameName=... (same as the other casino pages)
  const fetchMyBetsData = useCallback(async () => {
    const name = extractCasinoGame(pathname) || "lottcard";
    try {
      const response = await getCasinoOpenBets(name);
      if (response?.success && Array.isArray(response.data)) {
        setMyBets(
          response.data.map((bet) => ({
            description: bet.description ?? bet.game_name ?? bet.gameName,
            userName: bet.username || bet.userName || "-",
            matchedBet: bet.matchedBet || bet.nation || bet.selection || bet.player_name || "-",
            selection: bet.selection || bet.player_name || bet.matchedBet || "",
            player_name: bet.player_name || "",
            odds: bet.odds ?? bet.userrate ?? "0",
            stake: bet.stake ?? bet.amount ?? "0",
            placeDate: bet.placeDate ?? bet.created_at ?? "-",
            gametype: bet.gametype ?? bet.game_type ?? (bet.type === "lay" ? "Lay" : bet.type === "back" ? "Back" : "-"),
            type: bet.type || null,
            exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching my bets (open-downline):", error);
    }
  }, [pathname]);

  useEffect(() => {
    fetchMyBetsData();
    const intervalId = setInterval(fetchMyBetsData, 3000);
    return () => clearInterval(intervalId);
  }, [fetchMyBetsData]);

  const d = gameData?.data?.data || gameData?.data || {};
  const roundId = d?.mid || "";
  const title = "Lottery";

  return (
    <CasinoTableLayout
      tableClass="lottery"
      rightSide={<MyBet bets={myBets} onViewMore={() => setShowViewMoreModal(true)} formatNation={formatLottcardNation} />}
    >
      <>
        <CasinoHeading name={title} roundId={roundId} />
        <VideoBox
          gameType={gameName}
          resultData={d?.card}
          iframeSrc={`https://stream-s-43.uhdmovies.online/casino-stream?id=${gameName}`}
          timerValue={d?.lt}
          cardsOverlay={d?.card ? <RefCardsOverlay card={d.card} count={3} wrap /> : null}
        />{" "}
        {d?.remark ? (
          <div className="casino-remark mt-1">
            <div className="remark-icon">
              <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} alt="" />
            </div>{" "}
            <marquee>{d.remark}</marquee>
          </div>
        ) : null}{" "}
        <LottRefResults gameType={gameName} fallbackTitle={title} roundId={roundId} />
      </>
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={gameName}
        formatNation={formatLottcardNation}
      />
    </CasinoTableLayout>
  );
}
